import React from "react";

export const Timer: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 32 39"
    >
      <g fillRule="nonzero">
        <path d="M16 13.6c-.46 0-.833.358-.833.8v8.8c0 .442.373.8.833.8h9.167c.46 0 .833-.358.833-.8-.006-5.3-4.48-9.595-10-9.6z" />
        <path d="M28.51 13.902a.387.387 0 01.035-.528l2.752-2.641c.433-.402.607-.997.454-1.556a1.633 1.633 0 00-1.19-1.143 1.714 1.714 0 00-1.621.436l-2.76 2.65a.43.43 0 01-.548.034 16.106 16.106 0 00-7.602-3.026.406.406 0 01-.363-.397v-4.13c0-.106.043-.208.121-.283a.424.424 0 01.295-.118H21c.92 0 1.667-.716 1.667-1.6C22.667.716 21.92 0 21 0H11c-.92 0-1.667.716-1.667 1.6 0 .884.747 1.6 1.667 1.6h2.917c.23 0 .416.18.416.4v4.131a.404.404 0 01-.363.397C6.839 9.002 1.213 14.373.262 21.213c-.95 6.841 3.012 13.44 9.655 16.078 6.643 2.638 14.304.656 18.665-4.83 4.361-5.487 4.332-13.104-.072-18.559zM16 35.2c-6.904 0-12.5-5.373-12.5-12s5.596-12 12.5-12 12.5 5.373 12.5 12c-.007 6.624-5.6 11.993-12.5 12z" />
      </g>
    </svg>
  );
};
